export const setupWizard = {
  top: {
    title: "Einrichtungsassistent",
    subtitleFallback: "Grundeinrichtung des Inserats",
    stepCount: "Schritt {current} von {total}",
    closeAria: "Assistenten schließen",
    closeTitle: "Schließen",
  },
  intro: {
    title: "Richten wir Ihre Unterkunft gemeinsam ein!",
    subBefore: "Wir begleiten Sie Schritt für Schritt, damit",
    yourListingFallback: "Ihr Inserat",
    subAfter: "bereit ist, Gäste zu empfangen. Keine Technikkenntnisse nötig: In wenigen Minuten ist alles eingerichtet. 😊",
    start: "Jetzt starten!",
    skip: "Jetzt nicht, ich mache es später",
  },
  steps: {
    confirmation: {
      label: "Buchungsbestätigung",
      desc: "Wir informieren den Gast per WhatsApp und E-Mail, dass seine Buchung bestätigt ist. Wenn Sie das deaktivieren, wird er nicht benachrichtigt. Bucht er über eine OTA, benachrichtigt ihn die OTA.",
    },
    welcome: {
      label: "Willkommensnachricht",
      desc: "Die Nachricht, die der Gast direkt nach Abschluss seines Online-Check-ins erhält, mit der Begrüßung und den Anreisehinweisen.",
    },
    schedule: {
      label: "Check-in-Planung",
      desc: "Wann sollen wir dem Gast den Check-in-Link senden?",
    },
    hours: {
      label: "Check-in- und Check-out-Zeiten",
      desc: "Wann kann der Gast anreisen und abreisen?",
    },
    locks: {
      label: "Schlosstyp",
      desc: "Wie gelangt der Gast in Ihre Unterkunft?",
    },
    authorities: {
      label: "Meldung an die Behörden",
      desc: "Wir übermitteln die Gästemeldung für Sie an die Behörden, ohne dass Sie etwas tun müssen.",
    },
    services: {
      label: "Leistungen",
      desc: "Richten Sie die Leistungen und die Ausstattung Ihrer Unterkunft ein.",
    },
    policies: {
      label: "Richtlinien",
      desc: "Die Regeln und Bedingungen Ihrer Unterkunft.",
    },
    calendar: {
      label: "Kalender vorbereiten",
      desc: "Wir zeigen Ihnen, wie Sie Ihren Kalender für Buchungen vorbereiten.",
    },
  },
  nav: {
    back: "Zurück",
    next: "Weiter",
    finish: "Fertigstellen",
  },
  preview: {
    audienceOwner: "Ihre Ansicht (Gastgeber)",
    audienceGuest: "Was der Gast sieht",
    accommodationFallback: "Unterkunft",
    online: "online",
    today: "Heute",
    captionGuestWeb: "Vorschau · Gäste-Website",
  },
  schedule: {
    title: "Wann beginnt der Check-in?",
    hint: "Legen Sie fest, wann der Agent dem Gast den Check-in-Link sendet. Gilt auf Inseratsebene.",
    caption: "Vorschau · Check-in-Ablauf",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Soll die Buchungsbestätigung per WhatsApp an den Gast gesendet werden?",
    toggleHint: "Sobald eine Buchung bestätigt ist, erhält der Gast diese Nachricht mit allen Details zu seinem Aufenthalt. So weiß er, dass alles in Ordnung ist. 😊",
    stateOn: "Ja, senden",
    stateOff: "Nicht senden",
    mapAlt: "Lage der Unterkunft",
    addressFallback: "Adresse der Unterkunft",
    caption: "Vorschau · Bestätigungsnachricht",
    propFallback: "Ihre Unterkunft",
    guestSample: "Laura García",
    body: "Hallo *{guest}* 👋\n\nIhre Buchung bei *{name}* ist bestätigt ✅\n\nBuchungscode: *6233Q1VC5*\nZeitraum: *05/06/2026* – *07/06/2026* 📅\n\nÜber diesen WhatsApp-Chat können Sie Ihren Link für den Online-Check-in anfordern und die Anreisehinweise erhalten.\nWenn Sie vor oder während Ihres Aufenthalts Hilfe brauchen, schreiben Sie uns hier 💬",
    cta: "🇬🇧 Um mit dem Check-in fortzufahren, tippen Sie auf die Schaltfläche *Ok* oder schreiben Sie *Ok*.",
  },
  policies: {
    guestBubble: "Um mit dem Vorgang fortzufahren, müssen Sie unsere Allgemeinen Geschäftsbedingungen akzeptieren.",
    termsTitle: 'Hausordnung · TOURISTISCHE UNTERKUNFT "{name}"',
    termsBodyLabel: "I.– REGISTRIERUNG",
    termsBodyText: "Jeder Gast, ob einzeln oder als Teil einer Gruppe, muss ein Anmeldeformular einzeln oder pro Zimmer ausfüllen, das bei der Ankunft oder online bereitgestellt wird.",
    accept: "Ich akzeptiere die Allgemeinen Geschäftsbedingungen",
  },
  guestPreview: {
    continue: "Weiter",
  },
  authorities: {
    ofTotal: "von {total}",
    heading: "Nach dem Königlichen Dekret 933/2021 der spanischen Regierung erforderliche Angaben",
    intro: "Gemäß dem Königlichen Dekret 933/2021, das seit dem 2. Dezember 2024 gilt, müssen wir die folgenden Daten erheben, um die Sicherheitsvorschriften einzuhalten.",
    countryLabel: "Wohnsitzland",
    sampleCountry: "🇪🇸 Spanien",
    cityLabel: "Wohnort",
    sampleCity: "Málaga",
    addressLabel: "Wohnanschrift",
    sampleAddress: "Calle Larios 77",
    postalLabel: "Postleitzahl des Wohnsitzes",
  },
  locks: {
    embedEmpty: "Fügen Sie dem Inserat zuerst eine Einheit hinzu, um Schlösser und Zugang zu konfigurieren.",
  },
  calendar: {
    iframeTitle: "Kalender vorbereiten",
    videoSoon: "Das Video ist hier in Kürze verfügbar.",
    hint: "Spielen Sie das Video ab und folgen Sie den Schritten: Im Nu ist Ihr Kalender bereit für Buchungen. 🎬",
  },
};
